export default __webpack_public_path__ + "static/media/simple_spinner.cbc8d558.svg";